import React from 'react';

function PanelTextNav({options, value, onChange, ariaLabel = "보기 전환"}) {
    if (!options?.length) {
        return null;
    }

    return (
        <nav className="code-manage-panel__text-nav" aria-label={ariaLabel}>
            {options.map((option, index) => {
                const optionValue = option.value ?? option.id;
                const isActive = value === optionValue;

                return (
                    <React.Fragment key={optionValue}>
                        {index > 0 && (
                            <span className="code-manage-panel__text-nav-sep" aria-hidden="true">|</span>
                        )}
                        <button
                            type="button"
                            className={`code-manage-panel__text-nav-item${isActive ? " is-active" : ""}`}
                            aria-current={isActive ? "page" : undefined}
                            onClick={() => onChange(optionValue)}
                        >
                            {option.label}
                        </button>
                    </React.Fragment>
                );
            })}
        </nav>
    );
}

export default PanelTextNav;
